var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_13",
    "data-name": "\\uADF8\\uB8F9 13",
    transform: "translate(-1284 -457)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_21",
    "data-name": "\\uC0AC\\uAC01\\uD615 21",
    width: 36,
    height: 36,
    transform: "translate(1284 457)",
    fill: "#ff4848",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye-slash",
    "data-name": "Icon awesome-eye-slash",
    d: "M10.674,13.342A4.785,4.785,0,0,1,5.907,8.9l-3.5-2.7A11.117,11.117,0,0,0,1.184,8.052a1.079,1.079,0,0,0,0,.974,10.7,10.7,0,0,0,9.49,5.917,10.361,10.361,0,0,0,2.6-.349l-1.731-1.339A4.808,4.808,0,0,1,10.674,13.342ZM21.141,15.28l-3.687-2.85a11.049,11.049,0,0,0,2.71-3.4,1.079,1.079,0,0,0,0-.974,10.7,10.7,0,0,0-9.49-5.917A10.278,10.278,0,0,0,5.76,3.392L1.516.112A.534.534,0,0,0,.767.206l-.655.843A.534.534,0,0,0,.206,1.8L19.831,16.965a.534.534,0,0,0,.749-.094l.655-.843A.534.534,0,0,0,21.141,15.28Zm-6.128-4.736L13.7,9.53A3.161,3.161,0,0,0,9.83,5.463a1.589,1.589,0,0,1,.311.941,1.556,1.556,0,0,1-.051.334L7.633,4.84a4.747,4.747,0,0,1,3.04-1.1,4.8,4.8,0,0,1,4.8,4.8,4.689,4.689,0,0,1-.464,2Z",
    transform: "translate(1291.326 466.461)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.4a554cfc7cc25dc813087ef8e4bb4d30.svg";
export { ForwardRef as ReactComponent };